var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87088 5.70874C6.33198 5.70874 5.45355 7.46561 6.37689 8.69672C6.77097 9.22217 6.984 9.86126 6.984 10.5181V15.3923C6.984 17.3847 8.59918 18.9999 10.5916 18.9999H13.6296C15.622 18.9999 17.2372 17.3847 17.2372 15.3923V10.5181C17.2372 9.86126 17.4502 9.22217 17.8443 8.69672C18.7676 7.46561 17.8892 5.70874 16.3503 5.70874H7.87088ZM13.6294 9.32595C14.0436 9.32595 14.3794 9.66174 14.3794 10.0759V14.6329C14.3794 15.0471 14.0436 15.3829 13.6294 15.3829C13.2152 15.3829 12.8794 15.0471 12.8794 14.6329V10.0759C12.8794 9.66174 13.2152 9.32595 13.6294 9.32595ZM11.3415 10.0759C11.3415 9.66174 11.0057 9.32595 10.5915 9.32595C10.1772 9.32595 9.84145 9.66174 9.84145 10.0759L9.84145 14.6329C9.84145 15.0471 10.1772 15.3829 10.5915 15.3829C11.0057 15.3829 11.3415 15.0471 11.3415 14.6329V10.0759Z",
    fill: "#FFCACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1486 6.27848L14.8449 5.36754C14.5727 4.55086 13.8084 4 12.9476 4H11.2736C10.4128 4 9.64851 4.55086 9.37628 5.36754L9.07263 6.27848",
    stroke: "#FFCACA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.561bc2e20146f5354cd10514d5c5d7c9.svg";
export { ForwardRef as ReactComponent };